<template>
  <div>
    <BlockTitle :subtitle :title />
    <div class="flex h-[90vh] w-full flex-col">
      <!-- prefixing this component with "Base" prevents name conflicts and allows to stub it in the test -->
      <BaseAnimatedProductCheckpoints
        :categories="categoriesNames"
        class="h-[680px]"
        :i18n
        :trackClick
        trackingZone=""
      />

      <div v-if="button" class="mt-24 flex w-full justify-center">
        <CmsButton
          data-test="checkpoints-cta-button"
          v-bind="button"
          full-width="fixed"
          :tracking
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { AnimatedProductCheckpointsProps } from '@backmarket/http-api/src/api-specs-content/models/animated-product-checkpoints'
import BaseAnimatedProductCheckpoints from '@backmarket/nuxt-layer-cms/AnimatedProductCheckpoints.vue'
import BlockTitle from '@backmarket/nuxt-layer-cms/BlockTitle.vue'
import CmsButton from '@backmarket/nuxt-layer-cms/Button.vue'
import type { ContentBlockProps } from '@backmarket/nuxt-layer-cms/models/content-block'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

const props = defineProps<AnimatedProductCheckpointsProps & ContentBlockProps>()

const i18n = useI18n()
const { trackClick } = useTracking()

const categoriesNames = props.categories.map((category) => category.name)
</script>
